import React from "react";
import Reveal from "./Reveal";
import { MANIFESTO } from "../data/content";

export default function Manifesto() {
  return (
    <section id="manifesto" className="relative z-10 py-28 md:py-40 max-w-[1400px] mx-auto px-6 lg:px-12" data-testid="manifesto">
      <Reveal>
        <p className="text-sm font-500 tracking-[0.3em] uppercase text-[#D95A41] mb-6">The Manifesto</p>
        <h2 className="text-4xl md:text-6xl font-900 tracking-tightest max-w-4xl leading-[1] text-[#F2EFE9]">
          Founded on the belief that law should build, not block.
        </h2>
      </Reveal>

      <div className="mt-20 space-y-px">
        {MANIFESTO.map((m, i) => (
          <Reveal key={m.n} delay={i * 0.05}>
            <div className="group grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 py-12 border-t border-white/10 items-start">
              <div className="md:col-span-2 text-6xl md:text-7xl font-900 text-[#D95A41] tracking-tightest leading-none">
                {m.n}
              </div>
              <h3 className="md:col-span-4 text-2xl md:text-3xl font-700 text-[#F2EFE9] tracking-tight">
                {m.title}
              </h3>
              <p className="md:col-span-6 text-lg text-[#94A3B8] leading-relaxed">{m.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
